import { makeid } from 'utils/helpers/makeid';

import type { DateString } from 'infrastructure/types';
import type { INoteLog } from 'infrastructure/interfaces/i-note-log';

export class NoteLog {
  key: string;
  note: string;
  type: string;
  patientGuid: string;
  date: DateString;
  noteCreatedDate: DateString;
  author: string;
  professionType: string;
  constructor(data: INoteLog) {
    this.key = makeid(5);
    this.note = data.note;
    this.type = data.type;
    this.patientGuid = data.patientGuid;
    this.date = data.createdAt;
    this.noteCreatedDate = data.noteCreatedDate;
    this.author = `${data.createdByLogin.title} ${data.createdByLogin.firstName} ${data.createdByLogin.lastName}`;
    this.professionType = data.createdByLogin.professionType;
  }
}
